import { useAutoLogoutTracker } from "../../lib/custom_hooks/useAutoLogoutTracker";
import { useSelectPrivateUiAllowed } from "../../store";
import { IdleSignOutWarningPop, SessionCapWarning } from "..";

/** Mounted once, above the router, so it covers every route; the hook stays quiet while signed out. */
export const AutoTimeoutTracker = () => {
  const { signOutAt, capEndsAt, staySignedIn, signOut, stayPending } = useAutoLogoutTracker();
  // past an idle end the server has not answered for, the warning would cover the reconnecting banner
  const privateUiAllowed = useSelectPrivateUiAllowed();
  return (
    <>
      {capEndsAt !== null && <SessionCapWarning endsAt={capEndsAt} />}
      {signOutAt !== null && privateUiAllowed && (
        <IdleSignOutWarningPop
          signOutAt={signOutAt}
          stayPending={stayPending}
          onStaySignedIn={staySignedIn}
          onSignOut={signOut}
        />
      )}
    </>
  );
};
